var map = {
	"./en-US.json": "./core/i18n/resource/i18n/en-US.json",
	"./multistoreLanguages.json": "./core/i18n/resource/i18n/multistoreLanguages.json"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./core/i18n/resource/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;